module.exports = __webpack_public_path__ + "img/start.71192f2.svg";